import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    const dropZoneElement = this.element;
    const inputElement = dropZoneElement.querySelector(".drop-zone__input");

    dropZoneElement.addEventListener("click", (e) => {
      inputElement.click();
    });

    inputElement.addEventListener("change", (e) => {
      if (inputElement.files.length) {
        updateThumbnail(dropZoneElement, inputElement.files[0]);
      }
    });

    dropZoneElement.addEventListener("dragover", (e) => {
      e.preventDefault();
      dropZoneElement.classList.add("drop-zone--over");
    });

    ["dragleave", "dragend"].forEach((type) => {
      dropZoneElement.addEventListener(type, (e) => {
        dropZoneElement.classList.remove("drop-zone--over");
      });
    });

    dropZoneElement.addEventListener("drop", (e) => {
      e.preventDefault();

      if (e.dataTransfer.files.length) {
        const file = e.dataTransfer.files[0];
        const dataTransfer = new DataTransfer();
        dataTransfer.items.add(file);
        inputElement.files = dataTransfer.files;
        updateThumbnail(dropZoneElement, file);
        // Prévisualisation uniquement — l’upload se fait via le bouton Enregistrer.
        inputElement.dispatchEvent(
          new CustomEvent("file-drop:selected", { bubbles: true, detail: { file } })
        );
      }

      dropZoneElement.classList.remove("drop-zone--over");
    });

    /**
     * Updates the thumbnail on a drop zone element.
     *
     * @param {HTMLElement} dropZoneElement
     * @param {File} file
     */
    function updateAvatarFileCaption(dropZoneElement, fileName) {
      let caption = dropZoneElement.parentElement?.querySelector(".sidebar-my-account__avatar-file-caption");

      if (!caption) {
        caption = document.createElement("p");
        caption.className = "sidebar-my-account__avatar-file-caption mb-0 mt-2 text-muted text-center text-truncate";
        dropZoneElement.insertAdjacentElement("afterend", caption);
      }

      caption.textContent = fileName;
    }

    function updateThumbnail(dropZoneElement, file) {
      let thumbnailElement = dropZoneElement.querySelector(".drop-zone__thumb");

      // First time - remove the prompt
      if (dropZoneElement.querySelector(".drop-zone__prompt")) {
        dropZoneElement.querySelector(".drop-zone__prompt").remove();
      }

      // First time - there is no thumbnail element, so lets create it
      if (!thumbnailElement) {
        thumbnailElement = document.createElement("div");
        thumbnailElement.classList.add("drop-zone__thumb");
        dropZoneElement.appendChild(thumbnailElement);
      }

      if (dropZoneElement.classList.contains("sidebar-my-account__avatar-drop-zone")) {
        delete thumbnailElement.dataset.label;
        updateAvatarFileCaption(dropZoneElement, file.name);
      } else {
        thumbnailElement.dataset.label = file.name;
      }

      // Show thumbnail for image files (Object URL = instant preview, no async blank state)
      if (file.type.startsWith("image/")) {
        if (thumbnailElement.dataset.objectUrl) {
          URL.revokeObjectURL(thumbnailElement.dataset.objectUrl);
        }
        const objectUrl = URL.createObjectURL(file);
        thumbnailElement.dataset.objectUrl = objectUrl;
        thumbnailElement.style.backgroundImage = `url('${objectUrl}')`;
      } else {
        thumbnailElement.style.backgroundImage = null;
      }
    }
  }
}